import React from 'react';
import styled from 'styled-components';
import { COLOR } from '../../styles/colors';
import Font from '../../styles/font';

const StyledRadioList = styled.div`
  display: flex;
  flex-direction: column;

  & input[type='radio'] {
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  & label {
    color: ${COLOR.neutral95};
    margin-top: 8px;
  }

  & > label:last-child {
    margin-bottom: 16px;
  }
`;

export interface IRadioListItem {
  label: string; // What to display
  value: string; // The value selected
}

interface IRadioListProps {
  items: IRadioListItem[];
  name: string; // Name of the radio button group
  value?: string; // Value of selected radio button
  setValue: Function; // When an item is selected, this function is called with the VALUE of the item.
}

const RadioList: React.FC<IRadioListProps> = ({
  items,
  name,
  setValue,
  value
}) => {
  const handleRadioChange = event => {
    setValue(event.target.value);
  };

  return (
    <StyledRadioList>
      {items.map(item => (
        <label htmlFor={item.value} key={item.value}>
          <input
            type="radio"
            id={item.value}
            name={name}
            value={item.value}
            checked={item.value === value}
            className={Font.f16_tall}
            onChange={handleRadioChange}
          />
          {item.label}
        </label>
      ))}
    </StyledRadioList>
  );
};

export default RadioList;
